import {Injectable} from '@angular/core';
import {GeneraliExceptionService} from './generali-exception.service';
import {Link4ExceptionService} from './link4-exception.service';
import {MtuExceptionService} from './mtu-exception.service';
import {ApplicationStateService} from '../../shared/services/application-state.service';
import {BusinessParamName} from '../../shared/models/request-offer/request-offer.enum';
import {ProamaExceptionService} from './impl/proama-exception.service';
import {InsuranceCompanyCode} from '../../shared/models/insurance-company-code.enum';
import {UniqaExceptionService} from './uniqa-exception.service';
import {DialogService} from './dialog.service';
import {NavigateManagerService} from './navigate-manager.service';
import {TranslateService} from '@ngx-translate/core';
import {OfferService} from './impl/offer.service';
import {DialogAction, DialogKey} from '../../shared/components/dialogs/dialogs-configuration';
import {AppMode} from '../../shared/models/app-mode.enum';
import {InsuranceCompanyService} from '../../shared/services/insurance-company.service';

@Injectable()
export class InsuranceCompaniesAdditionalValidationService {

    constructor(private generaliExceptionService: GeneraliExceptionService,
                private proamaExceptionService: ProamaExceptionService,
                private mtuExceptionService: MtuExceptionService,
                private link4ExceptionService: Link4ExceptionService,
                private uniqaExceptionService: UniqaExceptionService,
                private stateService: ApplicationStateService,
                private dialogService: DialogService,
                private ts: TranslateService,
                private offerService: OfferService,
                private navigateManager: NavigateManagerService,
                private insuranceCompanyService: InsuranceCompanyService) {
    }

    public validate(): boolean {
        if (this.validateStartInsuranceDate()) {
            this.openStartInsuranceDateExceptionDialog();
            return true;
        }

        if (this.offerService.isRegistrationNumberMissing(this.stateService.selectedOffer.id)) {
            this.openMissingRegistrationNumberExceptionDialog();
            return true;
        }

        const companyCode = this.stateService.getBusinessParameterValue(BusinessParamName.INSURANCE_COMPANY_CODE);
        switch (companyCode) {
            case InsuranceCompanyCode.GENERALI: {
                if (this.generaliExceptionService.isValid()) {
                    return true;
                }
                break;
            }
            case InsuranceCompanyCode.MTU: {
                if (this.mtuExceptionService.isValid()) {
                    return true;
                }
                break;
            }
            case InsuranceCompanyCode.LINK4: {
                if (this.link4ExceptionService.isValid()) {
                    return true;
                }
                break;
            }
            case InsuranceCompanyCode.PROAMA: {
                if (this.proamaExceptionService.isValid()) {
                    return true;
                }
                break;
            }
            case InsuranceCompanyCode.UNIQA: {
                if (this.uniqaExceptionService.isValid()) {
                    return true;
                }
                break;
            }
            return false;
        }
    }

    private validateStartInsuranceDate(): boolean {
        const changedOffer = this.stateService.getBusinessParameterValue(BusinessParamName.CHANGED_OFFER);
        return changedOffer === 'startInsuranceDate';
    }

    private openStartInsuranceDateExceptionDialog(): void {
        const dynamicParagraphs = this.createDynamicParagraphsForDateException();
        this.dialogService.open(DialogKey.TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION, dynamicParagraphs);
        this.dialogService.addAction(DialogKey.TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION, {
            actionKey: DialogAction.BACK_TO_FIRST_STEP,
            callback: this.backToFirstStep.bind(this)
        });
    }

    private openMissingRegistrationNumberExceptionDialog(): void {
        this.dialogService.open(DialogKey.MISSING_REGISTRATION_NUMBER);
        this.dialogService.addAction(DialogKey.MISSING_REGISTRATION_NUMBER, {
            actionKey: DialogAction.BACK_TO_FIRST_STEP,
            callback: this.backToFirstStep.bind(this)
        });
    }

    private backToFirstStep(): void {
        if (this.stateService.mode === AppMode.WAITING_FOR_OFFER_LOADING) {
            this.stateService.mode = AppMode.WAITING_FOR_OFFER; // show first step content
        }
        this.navigateManager.moveToFirstStep();
    }

    private createDynamicParagraphsForDateException(): any {
        const { maxDaysToStartInsurance } = this.stateService.selectedOffer;
        const insuranceCompanyName = this.insuranceCompanyService.getInsuranceCompanyName(this.stateService.insuranceCompanyCode);

        const mainText = this.ts.instant('TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION_DIALOG_COMPONENT.mainText', { days: maxDaysToStartInsurance });
        const additionalText = this.ts.instant('TOO_DISTANT_START_INSURANCE_DATE_EXCEPTION_DIALOG_COMPONENT.additionalText', { days: maxDaysToStartInsurance, insuranceCompany: insuranceCompanyName });

        return { mainText, additionalText };
    }
}
